/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_StorageInputs */

const en_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const fr_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage`)
};

const de_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagerung`)
};

const it_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazzinaggio`)
};

const ru_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище`)
};

const es_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento`)
};

const zh_cn2_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贮存`)
};

const ja_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストレージ`)
};

const hi_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भंडारण`)
};

const pt_pt2_explorer_info_property_storage = /** @type {(inputs: Explorer_Info_Property_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenar`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Explorer_Info_Property_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_storage = /** @type {((inputs?: Explorer_Info_Property_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_storage(inputs)
	if (locale === "de") return de_explorer_info_property_storage(inputs)
	if (locale === "it") return it_explorer_info_property_storage(inputs)
	if (locale === "ru") return ru_explorer_info_property_storage(inputs)
	if (locale === "es") return es_explorer_info_property_storage(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_storage(inputs)
	if (locale === "ja") return ja_explorer_info_property_storage(inputs)
	if (locale === "hi") return hi_explorer_info_property_storage(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_storage(inputs)
	return en_explorer_info_property_storage(inputs)
});